import React, { useState } from 'react';
import './ForgotPassword.css';

interface ForgotPasswordProps {
  onBack: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // This will be replaced with actual password reset logic
      const { resetPasswordForEmail } = await import('../services/authService').then(m => m.authServiceClient);
      await resetPasswordForEmail(email);
      setIsSuccess(true);
    } catch (error: any) {
      
      if (error.message === 'No account found with this email address') {
        setError('No account found with this email address. Please check and try again.');
      } else if (error.message?.includes('rate limit')) {
        setError('Too many attempts. Please try again later.');
      } else {
        setError(`Failed to send reset email: ${error.message || 'Please try again.'}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="forgot-password-page">
        <div className="forgot-password-container">
          <div className="forgot-password-card">
            <div className="success-icon">✅</div>
            <h2>Check Your Email</h2>
            <p className="success-message">
              We've sent a password reset link to <strong>{email}</strong>
            </p>
            <p className="success-hint">
              The link will expire in 24 hours. If you don't see the email, check your spam folder.
            </p>
            <button 
              onClick={onBack}
              className="back-to-login-button"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <div className="forgot-header">
            <div className="logo">🔑</div>
            <h1>Forgot Password?</h1>
            <p className="tagline">No worries, we'll send you reset instructions</p>
          </div>

          <form onSubmit={handleSubmit} className="forgot-form">
            {error && <div className="error-alert">{error}</div>}
            
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                className="form-input"
                disabled={isLoading}
              />
            </div>

            <button 
              type="submit" 
              disabled={isLoading} 
              className="submit-button"
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <p className="back-link">
            Remember your password? <a href="#" onClick={(e) => { e.preventDefault(); onBack(); }}>Back to Login</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;